<div class="main-wrapper" fxLayout>
  <div *ngFor="let chip of chips; let i = index" [style.transform]="'translateX(' + (-25 * i)+ 'px)'">
    <div [@floatRight]="{ value: '', params: {delay: i * 200} }">
      <kl-chips [chip]="chip" size="md">
      </kl-chips>
    </div>
  </div>
</div>
